"use client";

import { Moon, Sun } from "lucide-react";
import { useEffect, useState } from "react";

export function ThemeToggle() {
  const [dark, setDark] = useState(false);
  const [ready, setReady] = useState(false);

  // Aktif tema <html> sınıfından okunur; bu bilgi sunucu render'ında yok
  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setDark(document.documentElement.classList.contains("dark"));
    setReady(true);
  }, []);

  function toggle() {
    const next = !dark;
    setDark(next);
    document.documentElement.classList.toggle("dark", next);
    localStorage.setItem("tema", next ? "koyu" : "acik");
  }

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={dark ? "Açık temaya geç" : "Koyu temaya geç"}
      className="grid size-9 place-items-center rounded-lg border border-border text-muted transition hover:bg-surface-muted hover:text-foreground"
    >
      {/* Hidrasyon öncesi ikon seçmeyelim; iki durumda da aynı boyut kaplar */}
      {ready && dark ? <Sun className="size-4" /> : <Moon className="size-4" />}
    </button>
  );
}
